import React, {useCallback, useMemo} from "react"
import {useFormik} from "formik"
import {useDispatch, useSelector} from "react-redux"
import {Helmet} from "react-helmet-async"
import {Button, Card, Col, Form, Row} from "antd"
import {StateType} from "../store/store"
import {changeUserSettings} from "../store/userReducer"
import {setMessage, setProfile} from "../store/appReducer"
import {FormSelect} from "../components/Form/FormSelect"

const notifyOptions = [
    {value: "0", label: "Выключено"},
    {value: "1", label: "Включено"},
    {value: "2", label: "Включено со звуком"},
]

export const Settings = () => {
    const dispatch = useDispatch()
    const profile = useSelector((state: StateType) => state.appReducer.profile)
    const status = useSelector((state: StateType) => state.appReducer.status)
    const controller = useMemo(() => new AbortController(), [])

    const formik = useFormik({
        initialValues: {
            notify: profile ? profile.notify?.toString() : "2",
        },
        enableReinitialize: true,
        onSubmit: async (values) => {
            if (profile) {
                const {payload}: any = await dispatch(changeUserSettings({
                    notify: parseInt(values.notify, 10),
                    controller,
                }))
                if (payload?.status === 0 && payload.data) {
                    dispatch(setProfile(payload.data))
                    dispatch(setMessage({type: "success", message: "Сохранено"}))
                }
            }
        },
    })
    const {values, handleChange, handleBlur, handleSubmit, errors, touched, setFieldValue, setValues} = formik

    const resetSettings = useCallback(() => {
        setValues({
            notify: profile ? profile.notify?.toString() : "2"
        })
    }, [profile])

    return (
        <div>
            <Helmet>
                <title>Настройки</title>
            </Helmet>
            <Row gutter={[24, 0]}>
                <Col xs={24}>
                    <Card variant="borderless"
                          className="criclebox tablespace mb-24"
                          title={
                              <div className="table-title">
                                  <div>Настройки</div>
                              </div>
                          }
                    >
                        <Form className="form-container"
                              style={{margin: "20px auto"}}
                              autoComplete="off"
                              onSubmitCapture={handleSubmit}
                        >
                            <FormSelect placeholder="Уведомления"
                                        value={values.notify}
                                        onChange={(value) => setFieldValue("notify", value)}
                                        options={notifyOptions}
                                        className="form-select"
                            />

                            <div className="form-button-block" style={{justifyContent: "center"}}>
                                <Button type="primary"
                                        htmlType="submit"
                                        disabled={values.notify === profile?.notify.toString()}
                                        loading={status === "loading"}
                                >
                                    Сохранить
                                </Button>
                                <Button type="default"
                                        onClick={resetSettings}
                                >
                                    Отмена
                                </Button>
                            </div>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

